module.exports = __webpack_public_path__ + "static/img/emqx-logo-open-source.56da828a.png";